import { useTranslation } from 'react-i18next';

import useSetting from "components/sidebarComponents/SidebarProject/use-settings";
import "./SidebarTabsContent.scss";

const GradientColorContent = () => {
  const { t } = useTranslation();
  
  const { settingsItems, addGradientData } = useSetting();

  const gradientData = settingsItems.gradientData
  const defaultColor = "#000"
  const firstValue = gradientData?.firstValue ?? defaultColor
  const secondValue = gradientData?.secondValue ?? defaultColor

  const updateGradientDataHandler = (updatedData) => {
    const currentGradientData = {
      firstValue,
      secondValue,
      ...updatedData
    }
    addGradientData(currentGradientData)
  }


  const onChangeHandler = (key) => (event) => updateGradientDataHandler({ [key]: event.currentTarget.value })

  return (
    <div className="color-content">
      <div className="gradient-wrapper">
        <div className="gradient-item-inner">
          <span className="gradient-item_title">{t('minimum')}</span>
          <input
            onChange={onChangeHandler('firstValue')}
            className="gradient-item_color-picker"
            value={firstValue}
            type="color"
          />
        </div>

        <div className="gradient-item_border"></div>

        <div className="gradient-item-inner">
          <span className="gradient-item_title">{t('maximum')}</span>
          <input
            onChange={onChangeHandler('secondValue')}
            className="gradient-item_color-picker"
            value={secondValue}
            type="color"
          />
        </div>
      </div>
    </div>
  );
};

export default GradientColorContent;
